'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import ApiExplorer from './ApiExplorer';
import HR from 'UIComponents/elements/HR';
import Markdown from './Markdown';

class DeveloperDoc extends Component {
  render() {
    const {
      className,
      specWithExtensions,
      oasDocs,
      newLayout
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      className: className || '',
      children: [specWithExtensions.info.description && /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Markdown, {
          children: specWithExtensions.info.description
        }), /*#__PURE__*/_jsx(HR, {})]
      }), /*#__PURE__*/_jsx(ApiExplorer, {
        oasDocs: oasDocs,
        oasFiles: {
          'api-setting': specWithExtensions
        },
        flags: {
          correctnewlines: false
        },
        newLayout: newLayout
      })]
    });
  }

}

DeveloperDoc.propTypes = {
  oasDocs: PropTypes.array,
  specWithExtensions: PropTypes.object,
  newLayout: PropTypes.bool,
  className: PropTypes.string
};
export default DeveloperDoc;